(function () {
  "use strict";

  angular
    .module("tikonApp")
    .factory("PosPaymentService", PosPaymentService);

  PosPaymentService.$inject = ["$resource"];

  function PosPaymentService($resource) {
    var baseUrl = "api/payment-logs/pos";

    return {

      sendToPos: function () {
        return $resource(
          baseUrl,
          {},
          {
            save: {
              method: "POST"
            }
          }
        );
      },
      
      checkStatus: function () {
        return $resource(
          baseUrl + "/:authorityToken",
          {
            authorityToken: "@authorityToken"
          },
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        );
      }
    };
  }
})();
